import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const BirdsEyeViewDashboard = () => import('@/views/BirdsEyeViewDashboard')
// const OnlinePresenceDashboard = () => import('@/views/OnlinePresenceDashboard')
const MessagingDashboard = () => import('@/views/MessagingDashboard')
const SocialDashboard = () => import('@/views/SocialDashboard')
const UserGroupsDashboard = () => import('@/views/UserGroups')
const AccountDashboard = () => import('@/views/Account')
const TeammateDetailDashboard = () => import('@/views/TeammateDetailDashboard')
const ChannelDetailDashboard = () => import('@/views/ChannelDetailDashboard')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Workspace Summary',
          component: BirdsEyeViewDashboard
        },
        {
          path: 'messaging',
          name: 'Message Activity',
          component: MessagingDashboard
        },
        {
          path: 'social',
          name: 'Social Activity',
          component: SocialDashboard
        },
        {
          path: 'details/channel',
          name: 'Channel Details',
          component: ChannelDetailDashboard
        },
        {
          path: 'details/teammate',
          name: 'Teammate Details',
          component: TeammateDetailDashboard
        },
        {
          path: 'org/groups',
          name: 'User Groups',
          component: UserGroupsDashboard
        },
        {
          path: 'org/account',
          name: 'Account',
          component: AccountDashboard
        }
      ]
    }
  ]
})

